import React from "react";
import Overview from "./Overview";
import Dashboard from "./Dashboard";
import { Switch, Route, Redirect } from "react-router-dom";

export default function Feedback() {
  return (
    <div className="feedback">
      <Switch>
        <Route path="/feedback/dashboard" component={Dashboard} />
        <Route path="/feedback/bot/:botHandle" component={Overview} />
        <Redirect from="/feedback" to="/feedback/dashboard" />
      </Switch>
    </div>
  );
}